import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { brandColors, chartSettings } from '../common/const'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface ResolveFailureCounterChartProps {
  labels: string[]
  dataSet: number[]
  chartTitle: string
  dataLabel: string
}

export const ResolveFailureCounterChart: React.FC<ResolveFailureCounterChartProps> = ({
  labels, dataSet, chartTitle, dataLabel
}) => {
  const data: ChartData<'bar'> = {
    labels,
    datasets: [
      {
        label: dataLabel,
        data: dataSet,
        backgroundColor: brandColors.safe,
        borderWidth: 0,
        borderRadius: 2,
      },
    ]
  }

  return <Bar data={data} options={{
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
      title: { display: true, text: chartTitle },
    },
    scales: {
      x: { stacked: false },
      y: { stacked: false },
    },
  }} {...chartSettings} />
}